import { HTMLAttributes, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import ControlledInputText from 'typescript/components/forms/controlled_input_text';
import AddressSuggestions from 'typescript/apps/checkout_v3/components/address_form/address_suggestions';
import {
  AddressType,
  getAddressPrefix,
} from 'typescript/schemas/address_forms/address_fields';
import styles from 'typescript/apps/checkout_v3/components/address_form/address_fields/address_fields.module.scss';

interface AddressLine1Props extends HTMLAttributes<HTMLElement> {
  addressType?: AddressType;
  addressSuggestionsEnabled?: boolean;
  disabled?: boolean;
}

const AddressLine1 = ({
  className,
  addressType = AddressType.shipping,
  addressSuggestionsEnabled = true,
  disabled = false,
}: AddressLine1Props) => {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const prefix = useMemo(() => getAddressPrefix(addressType), [addressType]);

  return (
    <>
      <AddressSuggestions
        className={`${className} ${addressSuggestionsEnabled ? styles.visible : styles.hidden}`}
        addressType={addressType}
      />
      <ControlledInputText
        className={`${className} ${addressSuggestionsEnabled ? styles.hidden : styles.visible}`}
        control={control}
        name={`${prefix}address_line_1`}
        label={t('checkout.delivery.addressLabel.addressLine1')}
        disabled={disabled}
      />
    </>
  );
};

export default AddressLine1;
